'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTemplateQuantitySelector = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _QuantitySelector2 = require('./QuantitySelector');

var _VariantSelector = require('./../variant/VariantSelector');

var _pcSlateTools = require('@process-creative/pc-slate-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Template Quantity Selector
 *    Contains scripts for the Product Template Qty Selector
 *
 *  Version
 *    1.0.0 - 2020/07/06
 */

var ProductTemplateQuantitySelector = exports.ProductTemplateQuantitySelector = function (_QuantitySelector) {
  (0, _inherits3.default)(ProductTemplateQuantitySelector, _QuantitySelector);

  function ProductTemplateQuantitySelector(productTemplate, container) {
    (0, _classCallCheck3.default)(this, ProductTemplateQuantitySelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductTemplateQuantitySelector.__proto__ || Object.getPrototypeOf(ProductTemplateQuantitySelector)).call(this, container));

    _this.template = productTemplate;

    (0, _jquery2.default)(document).on(_VariantSelector.ON_VARIANT_CHANGE, function (e, variant) {
      return _this.useVariant(variant);
    });
    _this.useVariant(_this.getVariantData());
    return _this;
  }

  (0, _createClass3.default)(ProductTemplateQuantitySelector, [{
    key: 'getVariantData',
    value: function getVariantData() {
      var vs = this.template.swatches || this.template.variantSelector;
      return vs.getVariantData();
    }
  }, {
    key: 'useVariant',
    value: function useVariant(variant) {
      var inventory_policy = variant.inventory_policy,
          inventory_quantity = variant.inventory_quantity,
          inventory_management = variant.inventory_management,
          id = variant.id;

      //Adjust quantiy selector

      var max = null;
      if (inventory_policy == 'continue' || inventory_management == null) {} else {
        max = inventory_quantity - (0, _pcSlateTools.getCountOfVariantInCart)(id);
      }
      this.setMax(max);
    }
  }, {
    key: 'onCartFinished',
    value: function onCartFinished() {
      this.useVariant(this.getVariantData());
      (0, _get3.default)(ProductTemplateQuantitySelector.prototype.__proto__ || Object.getPrototypeOf(ProductTemplateQuantitySelector.prototype), 'onCartFinished', this).call(this);
    }
  }]);
  return ProductTemplateQuantitySelector;
}(_QuantitySelector2.QuantitySelector);